import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { HolidayColumns } from "../../../tableColumns/table-columns";
import { holidayJson } from "../../../DynamicFormsJson/MastersJSON/holiday";
import { getHoliday } from "../../../Slice/year.slice";

class HolidayMasterTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { yearList, getHoliday } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={holidayJson.formPath}
                    screenTitle={holidayJson.screenTitle}
                    fieldMeta={holidayJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={holidayJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={holidayJson.pdfFileName}
                    excelFileName={holidayJson.excelFileName}
                    showAddButton={holidayJson.showAddButton}
                    tableColumnsToFilter={holidayJson.tableColumnsToFilter}
                    tableColumns={HolidayColumns}
                    tableData={yearList?.holiday}
                    getTableData={getHoliday}
                    apiBaseURL={holidayJson.apiBaseURL}
                    baseIdColumn={holidayJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={"Add Hoiday"}
                    showDeleteIcon={true}
                    showViewButtonInTable={true}
                    formPathView={holidayJson.formPathView}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    yearList: state.year,
});
const mapDispatchToProps = {
    getHoliday,
};
export default connect(mapStateToProps, mapDispatchToProps)(HolidayMasterTable);
